import { FC } from 'react';
import { Card, Text } from '@qga/roo-ui/components';
import RefundOptionsForm from './components/RefundOptionsForm';

const RefundOptionsCard: FC = () => (
  <Card mb={[5, 8]}>
    <Text display="block" fontSize="lg" fontWeight="bold" mb={4}>
      How would you like to receive your refund?
    </Text>

    <RefundOptionsForm />
  </Card>
);

export default RefundOptionsCard;
